import { FolderInput, LayoutTemplate, ListChecks } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Templates — industry packs, onboarding checklists and the runs that apply
 * them (roadmap item 15, PRD US-15.1 … US-15.7).
 *
 * `/templates/:id` is fixed by ENTITY_ROUTES (`template`). `/templates/:id/edit`
 * is the editor, `/templates/runs/:id` one client's onboarding run. Other
 * features reach in through the URL only: the project page links to
 * `/templates?fromProject=<id>` ("Save as template") and a client page to
 * `/templates?client=<id>` (choose a pack for this client).
 */
export default defineFeature({
  key: "templates",
  title: "Templates",
  entities: ["template"],
  routes: [
    { path: "templates", lazy: () => import("./page") },
    { path: "templates/runs/:id", lazy: () => import("./run") },
    { path: "templates/:id", lazy: () => import("./detail") },
    { path: "templates/:id/edit", lazy: () => import("./editor") },
  ],
  nav: [
    {
      label: "Templates",
      to: "/templates",
      icon: LayoutTemplate,
      group: "delivery",
      order: 50,
      permission: "projects:read",
      description: "Industry packs and client onboarding",
    },
  ],
  commands: [
    { key: "templates.runs", label: "Onboarding runs", icon: ListChecks, to: "/templates?tab=runs", group: "navigate", permission: "projects:read", keywords: ["onboarding", "checklist", "saga"] },
    { key: "templates.curated", label: "Curated template packs", icon: LayoutTemplate, to: "/templates?source=system", group: "navigate", permission: "projects:read", keywords: ["industry", "pack", "real estate", "fashion"] },
    { key: "templates.save-project", label: "Save a project as a template", icon: FolderInput, to: "/templates?save=1", group: "actions", permission: "templates:manage", keywords: ["reuse", "copy"] },
  ],
});
